import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const TrashIcon: React.FC<NormalIconProps> = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="19" height="21" viewBox="0 0 512 588.889" onClick={props.onClick} className={props.className}>
		<path
			d="M5.269,255.707a103.173,103.173,0,0,0,103.06,103.06H318.542A103.173,103.173,0,0,0,421.6,255.707V18.994a8.835,8.835,0,0,0-8.834-8.834H14.1a8.834,8.834,0,0,0-8.834,8.834Z"
			transform="translate(45.158 230.122)"
			fill="#9dd9db"
			fillRule="evenodd"
		/>
		<path
			d="M26.283,53.926A22.131,22.131,0,0,1,52.7,70.562L73.69,162.9a22.1,22.1,0,0,1-16.637,26.442,23.272,23.272,0,0,1-4.917.53,22.1,22.1,0,0,1-21.524-17.2L9.646,80.338A22.074,22.074,0,0,1,26.283,53.926Zm101.882,61.541L151.78,28.926a22.083,22.083,0,0,1,42.608,11.631l-23.615,86.511a22.075,22.075,0,0,1-21.289,16.283,23.675,23.675,0,0,1-5.83-.766A22.119,22.119,0,0,1,128.164,115.467Z"
			transform="translate(153.853 300.791)"
			fill="#498688"
			fillRule="evenodd"
		/>
		<path
			d="M441.942,76.409h-49.91L376.838,44.166A74.03,74.03,0,0,0,310.232,2H208.88a73.876,73.876,0,0,0-66.605,42.2L127.08,76.409H77.17A73.679,73.679,0,0,0,3.556,150.023v3.946a44.222,44.222,0,0,0,44.168,44.168H471.388a44.222,44.222,0,0,0,44.168-44.168v-3.946A73.679,73.679,0,0,0,441.942,76.409Z"
			transform="translate(-3.556 -2)"
			fill="#498688"
			fillRule="evenodd"
		/>
	</svg>
);
